// extracted by mini-css-extract-plugin
module.exports = {"root":"ImageBlock--root--XvQW_","content":"ImageBlock--content--1MdKI","overlay":"ImageBlock--overlay--1sS8h"};